/** Reports whether Ask Input has text, quote context, or selected attachments to submit. */
export function hasAskInputQuery({ quote, value, attachments, hasPendingAttachments, }) {
    return (!!quote ||
        value.trim().length > 0 ||
        (!!attachments && attachments.length > 0) ||
        hasPendingAttachments);
}
//# sourceMappingURL=hasAskInputQuery.js.map